import React,{ useState,useEffect, useRef } from 'react';
import { ADD_ONS_TYPE, ADDON_PERSONAL_ACCIDENT, APP_TYPE_RENEWAL, APP_TYPE_WITH_UCF, COUNTRY_CODE, DEFAULT_SEAT_CAPACITY_MOTORCYCLE, INS_TYPE_CTPL, VEHICLE_TYPE_MOTORCYCLE,VEHICLE_TYPE_MOTORCYCLE_COMMERCIAL,WITH_RULE_ENGINE_ID,WITHOUT_RULE_ENGINE } from 'config/constant';
import DynamicFormField from './DynamicFormField'; 
import InsuranceService from 'services/InsuranceService';
import ReactSelect from '@common/ReactSelect';
import { saveInsurance, updateRenewalState } from "@src/store/slices/insurance";
import { useSelector,useDispatch } from 'react-redux';
import * as HELPER from "../../../config/helper";
import { updateInsuranceForm } from './FunctionList';
import { useLanguage } from '@src/context/LanguageContext';
import _ from 'lodash';
import { AUTHORIZED_WORKSHOP_ADDON_ID } from '@src/config/id/constant';

const isCountryId = COUNTRY_CODE ==='id' ? true : false;


const InsuranceForm = (props: any) => {
    const [value, setValue] = useState(3)
    const dispatch: any = useDispatch();
    const allState = useSelector((state: any) => state);
    const [reload, setreload] = useState<boolean>(false)
    const totalRef = useRef<any>(null);
    const insuranceState =  (allState.insurance && allState.insurance.createInsurance) ? allState.insurance.createInsurance: null;
    const isComprensive = (insuranceState && insuranceState.hasOwnProperty('insurance_type')) ? insuranceState.insurance_type: true; 
    // Validate input field of allow two decimal value 
    const regex = /^[0-9]+(\.[0-9]{0,2})?$/;     
    const {translations} = useLanguage();
    

    // logic for calculate basic and special total
    const updateAddonTotal:any = (value:any, type:any) => {
        if(COUNTRY_CODE==='id' && isRuleEngine()){
            return updateAddonTotalId(value, type);
        }
        if (!updateAddonTotal.basic) updateAddonTotal.basic = 0;
        if (!updateAddonTotal.special) updateAddonTotal.special = 0;

        if (type === "basic") updateAddonTotal.basic = value;
        if (type === "special") updateAddonTotal.special = value;

        const finalTotal = updateAddonTotal.basic + updateAddonTotal.special;

        if (totalRef.current) {
            totalRef.current.innerText = HELPER.addCurrencyFormatting(finalTotal);
        }
    };

    const totals = {
        basic: { min: 0, max: 0 },
        special: 0
    };

    const updateAddonTotalId = (value: any, type: any) => {

        if (type === "basic") {
            let min = 0, max = 0;

            // basic can be range
            if (typeof value === 'string' && value.includes('-')) {
                const [minStr, maxStr] = value.split('-').map((s: string) => s.trim());
                min = parseFloat(minStr || '0');
                max = parseFloat(maxStr || '0');
            } else {
                const val = parseFloat(value || '0');
                min = val;
                max = val;
            }

            totals.basic = { min, max };
        }

        if (type === "special") {
            // special is always single value
            totals.special = parseFloat(value || '0');
        }

        // final calculation
        const finalMin = totals.basic.min + totals.special;
        const finalMax = totals.basic.max + totals.special;

        let output =
            finalMin === finalMax
                ? HELPER.addCurrencyFormatting(finalMin)
                : `${HELPER.addCurrencyFormatting(finalMin)} - ${HELPER.addCurrencyFormatting(finalMax)}`;

        if (totalRef.current) {
            totalRef.current.innerText = output;
        }
    };

    const getFieldItem = (key: any) => {
        let filterItem = props?.sectionItem?.blocks?.[0].fields?.filter((item: any) => item.name === key)?.[0]
        return filterItem
    } 

    const getPrimaryInsuranceTypeValue = (fieldItem: any) => {
        const insuranceTypeValue = Array.isArray(fieldItem?.multi_year_value) && fieldItem.multi_year_value.length
            ? fieldItem.multi_year_value[0]
            : fieldItem?.value?.value

        return Number(insuranceTypeValue)
    }

    const getInsuranceTypePayload = (fieldItem: any) => {
        if (isCountryId) {
            const selectedInsuranceTypes =
                Array.isArray(fieldItem?.multi_year_value) && fieldItem.multi_year_value.length
                    ? fieldItem.multi_year_value
                    : [fieldItem?.value?.value].filter((value) => value !== undefined && value !== null && value !== '')

            return selectedInsuranceTypes.map((value: any) => Number(value))
        }

        return fieldItem?.value?.value
    }
    
    const onValueChange = (fieldItem: any) => {

        let hasAnyField:boolean = false;
        if(isCountryId){
            for(let row of props?.sectionItem?.blocks?.[0]?.fields){
                if(["vehicle_type", "insurance_type", "make_year", "plate_area"].includes(row?.name)){
                    if(row.value!=="" && row.value!==undefined && row.value!==null){
                        hasAnyField = true;
                    }else{
                        hasAnyField = false;
                        break
                    } 
                }
            }
        }
       
        if (!isCountryId && (fieldItem.name === "car_fmv" || fieldItem.name === "acc_price")) {
            //reset referrer mark up & net premium on fmv change
            if(props?.extraField) {
                let newFields = {...props.extraField}
                const keysToRemove = ['referrer_mark_up', 'net_premium']

                keysToRemove.forEach((key) => {
                    if(props.extraField[key]) delete newFields[key]
                })

                props.setExtraField(newFields)
            }

            setValue(value + 1)
        }else if (!isCountryId && (fieldItem.name === "vehicle_type" || fieldItem.name === "insurance_type" || fieldItem.name === "make_year")) {
            fetchAddons()
            if (fieldItem.name === "insurance_type") {  
                const insuranceTypeValue = getPrimaryInsuranceTypeValue(fieldItem)
                dispatch(saveInsurance({
                    insurance_type: insuranceTypeValue === 2 ? false: true
                }));
                
                props.handlePaymentTermTenure(insuranceTypeValue)
            }
        }else if (isCountryId && hasAnyField) {
            if (hasAnyField && ["vehicle_type", "insurance_type", "make_year", "plate_area","car_fmv","acc_price"].includes(fieldItem?.name)) {                
                const insuranceTypeValue = getPrimaryInsuranceTypeValue(fieldItem)
                debouncedFetchAddons();
                dispatch(
                    saveInsurance({
                        insurance_type: insuranceTypeValue === 2 ? false : true,
                    })
                );
                props.handlePaymentTermTenure(insuranceTypeValue);
            }
        }
        else if(fieldItem.name === "car_under_finance"){
            SetActNature();
        }  
    }

    const SetActNature = async () => {
        let carfinanceTypeItem = getFieldItem('car_under_finance');
        let insuranceTypeItem = getFieldItem('insurance_type'); 
        let is_required=(getPrimaryInsuranceTypeValue(insuranceTypeItem)===1 && +carfinanceTypeItem.value.value===1)?true:false;
        let fieldItem = getFieldItem('addon_detail');
        let originalList = fieldItem.original_list;
        if(originalList?.length>0){
            originalList=originalList.map((ob:any)=>{
                return {
                    ...ob,is_required:(ob.id===6)?is_required:ob.is_required,is_selected:(ob.id===6)?is_required:ob.is_selected
                }
            })
            fieldItem['original_list'] = originalList;
            setValue(value + 1)
        }
        
    }

    const fetchAddons = async () => {
        let vehicleTypeItem = getFieldItem('vehicle_type')
        let insuranceTypeItem = getFieldItem('insurance_type') 
        let makeYearItem = getFieldItem('make_year') 
        let plateAreaItem = getFieldItem('plate_area')
        let accPriceItem = getFieldItem('acc_price')
        let carFMVItem = getFieldItem('car_fmv')
        
        if (vehicleTypeItem?.value && insuranceTypeItem?.value) {
            props.setLoading(true)
            let params:any = { rule_engine: props.applicationType, vehicle_type: vehicleTypeItem.value.value, apptype: props.apptype ?? 2, insurance_type: getInsuranceTypePayload(insuranceTypeItem), make_year: makeYearItem.value.value }
            if(isCountryId) {
                // delete params.rule_engine;
                delete params.apptype;
                params.plate_area_type = plateAreaItem?.value?.plate_area_type
                params.total_fmv = (+accPriceItem.value + +carFMVItem?.value)
                const insuranceTypes = Array.isArray(params.insurance_type) ? params.insurance_type : []
                const multi_year = insuranceTypes.map((row:any)=>{
                    return {
                        insurance_type: row
                    }
                })
                params.multi_year = multi_year
                delete  params.insurance_type
                const tenure = getFieldItem('tenure')
                params.tenure = tenure?.value?.value
                const vehicle_condition = +getFieldItem('vehicle_condition')?.value?.value
                const vehicle_usage = +getFieldItem('vehicle_usage')?.value?.value
                params.vehicle_condition = vehicle_condition
                params.vehicle_usage = vehicle_usage

            }
            let result =  isCountryId ? await InsuranceService.getAddonListID(params) : await InsuranceService.getAddonList(params)
            if (result?.data?.data) {
                let originalList = isCountryId ?result.data.data?.basic :result.data.data;
                if(result?.data?.data?.special?.length > 0) originalList = originalList.concat(result.data.data.special)
                
                let fieldItem = getFieldItem('addon_detail');
                let carfinanceTypeItem = getFieldItem('car_under_finance');

                let is_required=(carfinanceTypeItem && +carfinanceTypeItem?.value?.value===1)?true:false;
                //for renewal application, check if pa selected in last lead
                let renewalParentAddons = allState?.insurance?.leadDetail?.addon_detail
                
                if(is_required && originalList.length>0){
                    originalList=originalList.map((ob:any)=>{
                        return {
                            ...ob,is_required:(ob.id===6)?is_required:ob.is_required,is_selected:(ob.id===6)?is_required:ob.is_selected
                        }
                    })
                }
                
                //pre-fill renewal addons
                if(props.apptype === APP_TYPE_RENEWAL) {
                    originalList = originalList.map((addon: any) => {
                        let parentAddon = renewalParentAddons.find((e: any) => e.id === addon.id)
                        if(parentAddon?.premium_amount && !(isRuleEngine())) addon['premium_amount'] = parentAddon.premium_amount
                        if(parentAddon?.premium_amount && addon.type === "pa") addon['premium_amount'] = parentAddon.premium_amount
                
                        //prefill pa
                        if (parentAddon?.id && addon.id === 3) {
                            return {
                                ...addon,
                                is_selected: true,
                                coverage_amt: parentAddon?.coverage_amount,
                                seat_capacity: parentAddon?.seat_capacity,
                                extra_seat_value: parentAddon?.extra_seat_capacity,
                            }
                        }

                        return {
                            ...addon,
                            coverage_amt: parentAddon?.coverage_amount || addon.converage_amt,
                            is_selected: parentAddon?.id ? true : false
                        }
                    })
                }

                fieldItem['original_list'] = originalList;                
                setValue((value)=> value + 1)
            }
            props.setLoading(false)

        }
    }


    const onValueSelect = (addonItem: any, event: any) => {
        addonItem['coverage_amt'] = event.value
        if (!isCountryId && isComprensive && props.applicationType===WITH_RULE_ENGINE_ID && addonItem.type === 'bi') {
            const oppositeAddon = addonList()?.find((item: any) => item.type === 'pd');
            if (oppositeAddon) {
                oppositeAddon.coverage_amt = event.value;
            }
        }
        setValue(value + 1)
    }

    const isRuleEngine = () => {
        if (props?.applicationType === 1) return true
        else return false
    }

    const getPremiumAmount = (item: any) => {
        if ((isComprensive || isCountryId) && isRuleEngine()) {
            if (ADD_ONS_TYPE.PERSONAL_ACCIDENT === item.type) {
                return item.premium_amount || ''
            }
            let filterItem = item?.coverage_list?.filter((option: any) => option.value === item.coverage_amt)?.[0]
            if (filterItem){
                if(isCountryId && item.type==="tjh"){
                    return filterItem?.alt_premium_amount;
                }
                else if(isCountryId && item?.default_passenger){
                    return filterItem?.premium_amount *  (item?.seat_capacity || item?.default_passenger);
                }
                else{
                    return filterItem?.premium_amount || ''
                }
            }
            else{
                if(isCountryId){
                    // const totalFmv  = props?.sectionItem?.blocks?.[0]?.fields?.find((row:any)=>row.name==="total_fmv")?.value;
                    // return Math.round((parseFloat(totalFmv) * parseFloat(item?.rate)) / 100)
                    return item.premium_amount;
                }else{
                    return 0
                }
            }
        }
        else {
            return item.premium_amount ? item.premium_amount : ''
        }
    }

    const getPremiumTitle = (item: any, key: string) => { 
        if (ADD_ONS_TYPE.PERSONAL_ACCIDENT === item.type && isComprensive && isRuleEngine()) {
            return ''
        }
        else if (ADD_ONS_TYPE.ACTS_OF_NATURE === item.type || ADD_ONS_TYPE.RIOTS_STRIKES_CIVIL === item.type || ADD_ONS_TYPE.TOWING_ROWDSIDE === item.type) {
            return ''
        } else if ((isComprensive || isCountryId) && isRuleEngine()) {
            if(key === "title"){
                return isCountryId ? translations?.CREATE_APPLICATION?.PREMIUM_AMOUNT :"Premium Amount :"
            }else{
                return HELPER.addCurrencyFormatting(getPremiumAmount(item))
            }
        }
        return ''
    }

    const isShowAlreadyIncluded = (addonItem: any) => {
        if ((ADD_ONS_TYPE.RIOTS_STRIKES_CIVIL === addonItem.type || ADD_ONS_TYPE.TOWING_ROWDSIDE === addonItem.type) && !addonItem?.is_editable) return true;

        return false
    }

    const calculateTotalPremiumValue = () => {
        if(COUNTRY_CODE==='id' && isRuleEngine()){
            return calculateTotalPremiumValueId();
        }
        let total = 0
        let filterList = addonList()?.filter((item: any) => item?.is_selected)
        if (filterList?.length) {
            filterList?.forEach((item: any) => {
                let premiumAmount = getPremiumAmount(item)
            if (ADD_ONS_TYPE.ACTS_OF_NATURE !== item.type)
                    if (premiumAmount)
                        total += parseFloat(premiumAmount ?? '0')
            })
        }
        console.log('total==',total);
        
        return HELPER.addCurrencyFormatting(total)
    }

    const calculateTotalPremiumValueId = () => {
        let minTotal = 0;
        let maxTotal = 0;

        let filterList = addonList()?.filter((item: any) => item?.is_selected);

        if (filterList?.length) {
            filterList.forEach((item: any) => {
                if (ADD_ONS_TYPE.ACTS_OF_NATURE === item.type) return;

                let premiumAmount = getPremiumAmount(item);

                if (!premiumAmount) return;

                if (typeof premiumAmount === 'string' && premiumAmount.includes('-')) {
                    const [minStr, maxStr] = premiumAmount.split('-').map((s: string) => s.trim());

                    const min = parseFloat(minStr || '0');
                    const max = parseFloat(maxStr || '0');

                    minTotal += min;
                    maxTotal += max;
                } 
                // Agar single value hai
                else {
                    const value = parseFloat(premiumAmount || '0');
                    minTotal += value;
                    maxTotal += value;
                }
            });
        }

        // Format output
        if (minTotal === maxTotal) {
            return HELPER.addCurrencyFormatting(minTotal);
        }

        return `${HELPER.addCurrencyFormatting(minTotal)} - ${HELPER.addCurrencyFormatting(maxTotal)}`;
    };

    const onChangeCheckbox = (addonItem: any, event: any) => {
        if (addonItem.is_required) {
            addonItem.is_selected = true
        } else {
            addonItem['is_selected'] = !addonItem.is_selected
        }

        if(isCountryId){
            addonItem.coverage_amt = addonItem.default_sum_insured
            addonItem.coverage_list = addonItem.coverage_list?.map((row:any)=>{
                return {
                    ...row,
                    // label:HELPER.addCurrencyFormatting(row.label)
                    label:row.label
                }
            }) 
            if(addonItem?.default_passenger){
                addonItem.seat_capacity = addonItem?.default_passenger
            }
        }else{
            if (isComprensive && props.applicationType===WITH_RULE_ENGINE_ID && addonItem.type === 'bi') {
                const oppositeAddon = addonList()?.find((item: any) => item.type === 'pd');
                if (oppositeAddon) {
                    if (oppositeAddon.is_required) {
                        oppositeAddon.is_selected = true
                    } else {
                        oppositeAddon['is_selected'] = !oppositeAddon.is_selected
                    }
                }
            }
        }    
        setValue(value + 1)
    }

    const isShowPremiumInputBox = (addonItem: any) => {
        if (((!isComprensive && !isRuleEngine()) || (!isRuleEngine() && isComprensive)) && ADD_ONS_TYPE.RIOTS_STRIKES_CIVIL !== addonItem.type && ADD_ONS_TYPE.TOWING_ROWDSIDE !== addonItem.type){
            return true
        }
        else{
            if(addonItem.is_editable && !isRuleEngine()){ //ONLY IN CASE OF TRA WITHOUT RULE ENGINE
                return true
            }else{
                //FOR OONA & MERCENTILE IF COVERAGE AMT IS MATCHED FROM API THEN SHOW INPUT BOX
                if(addonItem.type === ADD_ONS_TYPE.PERSONAL_ACCIDENT){                    
                    if (addonItem.coverage_amt === addonItem.oona_coverage_amount_limit || addonItem.coverage_amt === addonItem.milestone_coverage_amount_limit) {
                        addonItem.premium_amount = ''
                        return false
                    } 
                    else if (
                        [VEHICLE_TYPE_MOTORCYCLE, VEHICLE_TYPE_MOTORCYCLE_COMMERCIAL].includes(getFieldItem('vehicle_type')?.value?.value) &&
                        isComprensive &&
                        isRuleEngine()) {
                        return false
                    } else {
                        return (addonItem.coverage_amt) ? true : false //MANUAL PREMIUM INPUT ALLOW 
                    }

                }else{
                    return false
                } 
            }
        }
    }

    const onChangePremiumAmount = (addonItem: any, text: any) => {
        // validate two decimal digit value
        if (regex.test(text) || text === '') {
            if (!isComprensive && isRuleEngine())
                addonItem.coverage_amt = text ? text : ''
            else
                addonItem.premium_amount = text ? text : ''
                setValue(value + 1)
        }
    }

    const addonList = () => {
        let addonFieldItem = getFieldItem('addon_detail'); 
        return addonFieldItem?.original_list || []
    }

    const resetAddonList = () => {
        setValue(value + 1)
    }

    const getSeatingCapacityList = (item: any) => {
        let versionSeat = props?.versionSeat
        if (versionSeat) {
            item.seat_capacity = versionSeat
            return [{ value: versionSeat, label: versionSeat }]
        }
        if (!versionSeat) {
            versionSeat = item.extra_seat_capacity
        }
        if (versionSeat) {
            versionSeat = +versionSeat
            var tempList = []
            for (var index = 1; index <= versionSeat; index++) {
                const optionParam = {
                    "value": index,
                    "label": index
                }
                tempList.push(optionParam)
            }
            return tempList
        }

        //motorcycle version seat
        if (!versionSeat) {
            const vehicleType = getFieldItem('vehicle_type')
            if (vehicleType?.value?.value === VEHICLE_TYPE_MOTORCYCLE) {
                return [{ label: DEFAULT_SEAT_CAPACITY_MOTORCYCLE, value: DEFAULT_SEAT_CAPACITY_MOTORCYCLE }]
            }
        }
        return []
    }

    const getExtraSeatingCapacityList = (item: any) => {
        let versionSeat = item.extra_seat_capacity

        if (versionSeat) {
            versionSeat = +versionSeat
            var tempList = []
            for (var index = 1; index <= versionSeat; index++) {
                const optionParam = {
                    "value": index,
                    "label": index
                }
                tempList.push(optionParam)
            }
            return tempList
        }
        return []
    }

    const saveExtraSeatingValue = (item: any, event: any) => {
        item.extra_seat_value = event.value  
        setValue(value + 1)

    } 
    
    const saveSeatingValue = (item: any, event: any) => {
        item.seat_capacity = event.value
        setValue(value + 1)
    };

    const calculateTotalFMV = ()=>{
        let carFMVItem = getFieldItem('car_fmv')
        let accPriceItem = getFieldItem('acc_price')
        let totalValue = 0
        if (carFMVItem?.value)
            totalValue = parseFloat(carFMVItem.value)

        if (accPriceItem?.value)
            totalValue += parseFloat(accPriceItem.value) 
        return HELPER.addCurrencyFormatting(totalValue);
    }

    useEffect(() => {
        let insuranceFormSection: Array<any> = props.sectionItem?.['blocks']?.[0]?.['fields']

        if (props.apptype === APP_TYPE_WITH_UCF) {
            if (allState.insurance.activeLoanID && Object.keys(allState.insurance.activeLoanID).length) {
                updateInsuranceForm(allState.insurance.activeLoanID, insuranceFormSection)
                props.onVersionSelect({})
            } else updateInsuranceForm({}, insuranceFormSection, [], true)

            setreload(!reload)
        }

       // eslint-disable-next-line
    }, [props.apptype, allState.insurance.activeLoanID, props.sectionItem])


    useEffect(() => {
        let insuranceFormSection: Array<any> = props.sectionItem?.['blocks']?.[0]?.['fields']

        if (props.apptype === APP_TYPE_RENEWAL && !allState?.insurance?.renewalUpdateFlag?.insuranceForm) {
            if (allState.insurance.leadDetail && Object.keys(allState.insurance.leadDetail).length) {
                updateInsuranceForm({ ...allState.insurance.leadDetail, type: 'renewal' }, insuranceFormSection).then(() => {
                    //update insurance_type to update isComprehensive flag
                    let { insurance_type } = allState.insurance.leadDetail
                    dispatch(saveInsurance({
                        insurance_type: (insurance_type === INS_TYPE_CTPL) ? false: true
                    }));
                    
                    props.handlePaymentTermTenure(insurance_type)
                })
                props.onVersionSelect({})
                fetchAddons()
                dispatch(updateRenewalState({ ...allState?.insurance?.renewalUpdateFlag, insuranceForm: true }))

            } else updateInsuranceForm({}, insuranceFormSection, [], true)

            setreload(!reload)
        }
        // eslint-disable-next-line
    }, [props.apptype, allState.insurance.leadDetail, props.sectionItem])

    const debouncedFetchAddons = _.debounce(() => {
        fetchAddons();
    }, 1000)
    
   
    const basicAddons = addonList()?.filter((addonItem: any) => addonItem?.id <= AUTHORIZED_WORKSHOP_ADDON_ID
);
    const specialAddons = addonList()?.filter((addonItem: any) => addonItem?.id > AUTHORIZED_WORKSHOP_ADDON_ID);

    const AddonComponent = ({ addons,title,totalRef,onSumUpdate }: { addons: any[],title:string,totalRef:any,onSumUpdate:any }) => {
        // logic for focus out issue
        const [premiumMap, setPremiumMap] = useState<any>({});

        const calculateLiveTotal = () => {

           if(COUNTRY_CODE==='id' && isRuleEngine()){
                return calculateLiveTotalRange();
            }
            let total = 0;

            addons.forEach((item) => {
                const premium = premiumMap[item.id] ?? getPremiumAmount_ID(item);

                if (item.is_selected && premium) {
                    total += parseFloat(premium || 0);
                }
            });

            // Send total to parent without causing re-render
            onSumUpdate(total);
        };

        const calculateLiveTotalRange = () => {
            let minTotal = 0;
            let maxTotal = 0;

            addons.forEach((item) => {
                if (!item.is_selected) return;

                const premium = premiumMap[item.id] ?? getPremiumAmount_ID(item);
                if (!premium) return;

            
                if (typeof premium === 'string' && premium.includes('-')) {
                    const [minStr, maxStr] = premium.split('-').map((s: string) => s.trim());

                    const min = parseFloat(minStr || '0');
                    const max = parseFloat(maxStr || '0');

                    minTotal += min;
                    maxTotal += max;
                } 
                else {
                    const value = parseFloat(premium || '0');
                    minTotal += value;
                    maxTotal += value;
                }
            });

            if (minTotal === maxTotal) {
                onSumUpdate(HELPER.addCurrencyFormatting(minTotal));
            } else {
                onSumUpdate(
                    `${HELPER.addCurrencyFormatting(minTotal)} - ${HELPER.addCurrencyFormatting(maxTotal)}`
                );
            }
        };




        const onChangePremiumAmount_ID = (addonItem: any, text: any) => {
        // validate two decimal digit value
        if (regex.test(text) || text === '') {
            setPremiumMap((prev:any) => ({
            ...prev,
            [addonItem.id]: text
        }));
        
            if (!isComprensive && isRuleEngine())
                addonItem.coverage_amt = text ? text : ''
            else
                addonItem.premium_amount = text ? text : ''
                //setValue(value + 1)
        }
    }

    const getPremiumAmount_ID = (item: any) => {
        if (premiumMap[item.id] !== undefined) {
            return premiumMap[item.id];
        }

        if ((isComprensive || isCountryId) && isRuleEngine()) {
            if (ADD_ONS_TYPE.PERSONAL_ACCIDENT === item.type) {
                return item.premium_amount || ''
            }
            let filterItem = item?.coverage_list?.filter((option: any) => option.value === item.coverage_amt)?.[0]
            if (filterItem){
                if(isCountryId && item.type==="tjh"){
                    return filterItem?.alt_premium_amount;
                }
                else if(isCountryId && item?.default_passenger){
                    return filterItem?.premium_amount *  (item?.seat_capacity || item?.default_passenger);
                }
                else{
                    return filterItem?.premium_amount || ''
                }
            }
            else{
                if(isCountryId){
                    const totalFmv  = props?.sectionItem?.blocks?.[0]?.fields?.find((row:any)=>row.name==="total_fmv")?.value;
                    return Math.round((parseFloat(totalFmv) * parseFloat(item?.rate)) / 100)
                }else{
                    return 0
                }
            }
        }
        else {
            return item.premium_amount ? item.premium_amount : ''
        }
    }

        useEffect(() => {
            calculateLiveTotal();
        }, [premiumMap, addons]);

        return (
            addons?.length  ?
            <div className="form-group-bx ">
                <div className=''>
                    <h3>{title}</h3>
                    {   
                        addons?.map((addonItem: any, index: number) => {
                            const isVehicleTypeMotorCycle = [VEHICLE_TYPE_MOTORCYCLE, VEHICLE_TYPE_MOTORCYCLE_COMMERCIAL].includes(getFieldItem('vehicle_type')?.value?.value);
                            let className = 'row'

                            if(isCountryId && +addonItem?.coverage_list.length === 0){
                                className = 'alignment'
                            }

                            return (<div className={className} key={index}>
                                <fieldset className={"form-filed common-application-checkbox " + (([ADD_ONS_TYPE.RIOTS_STRIKES_CIVIL, ADD_ONS_TYPE.TOWING_ROWDSIDE].includes(addonItem.type) || (isRuleEngine() && addonItem.type === ADD_ONS_TYPE.ACTS_OF_NATURE)) ? "col-md-6" : isCountryId && className ==='alignment'? "":"col-md-12")}>
                                    <div className="custom-control custom-checkbox check-box-small col-md-12">
                                        <input checked={addonItem.is_selected} id="Individual" type="checkbox" className="custom-control-input " name="Buyer Type" onChange={(event) => {
                                            onChangeCheckbox(addonItem, event)
                                        }} disabled={addonItem.id === ADDON_PERSONAL_ACCIDENT && allState?.insurance?.leadDetail?.addon_detail?.find((e: any) => e.id === ADDON_PERSONAL_ACCIDENT && e.seat_capacity)} />
                                        <label className="custom-control-label checkbox-label-txt"><span>{addonItem.name}</span></label>
                                    </div>
                                </fieldset>
                                {
                                    addonItem?.is_selected &&
                                    <>
                                        <div className='addon-box-parent'>

                                            {addonItem.coverage_list?.length > 0 &&
                                                <ReactSelect
                                                    // options={addonItem.coverage_list || []}
                                                    options={addonItem.coverage_list.map((item: any) => ({
                                                        ...item,
                                                        label: (item.label && COUNTRY_CODE === 'id') ? HELPER.addCurrencyFormatting(item.label) : item.label,
                                                    }))}
                                                    value={addonItem?.coverage_amt ? { label: isCountryId ? HELPER.addCurrencyFormatting(addonItem.coverage_amt):addonItem.coverage_amt, value: addonItem.coverage_amt } : null}
                                                    handleChange={(e: any, fieldKey: string) => onValueSelect(addonItem, e)} placeholder={translations?.CREATE_APPLICATION?.CHOOSE_COVERAGE_AMOUNT || 'Choose Coverage Amount' }
                                                    fieldKey=""
                                                    isDisabled={isCountryId?false: !isComprensive ? true : false} fieldSetClassName="col-md-4"
                                                />
                                            }

                                            {addonItem.type === 'pa' && <>
                                                <ReactSelect
                                                    options={getSeatingCapacityList(addonItem)}
                                                    placeholder="Seating Capacity"
                                                    isDisabled={(props.versionSeat || allState?.insurance?.leadDetail?.addon_detail?.find((e: any) => e.id === ADDON_PERSONAL_ACCIDENT && e.seat_capacity) || isVehicleTypeMotorCycle)}
                                                    value={props.versionSeat ? { label: props.versionSeat, value: props.versionSeat } : addonItem.seat_capacity ? { label: addonItem.seat_capacity, value: addonItem.seat_capacity } : null}
                                                    handleChange={(e: any) => saveSeatingValue(addonItem, e)} fieldSetClassName="col-md-4"
                                                />

                                                {
                                                    !isVehicleTypeMotorCycle
                                                        ? <ReactSelect
                                                            options={getExtraSeatingCapacityList(addonItem)}
                                                            placeholder="Extra Seating Capacity"
                                                            isDisabled={props.apptype === APP_TYPE_RENEWAL ? false : allState?.insurance?.leadDetail?.pa_extra_seating_capacity}
                                                            value={addonItem?.extra_seat_value ? { label: addonItem.extra_seat_value, value: addonItem.extra_seat_value } : null}
                                                            handleChange={(e: any) => saveExtraSeatingValue(addonItem, e)} fieldSetClassName="col-md-4"
                                                        />
                                                        : <div className='col-md-4'></div>
                                                }
                                            </>
                                            }
                                                

                                            {
                                                isCountryId && addonItem?.seat_capacity_list && (
                                                    <ReactSelect
                                                    options={addonItem.seat_capacity_list}
                                                    placeholder= {translations?.CREATE_APPLICATION?.SEATING_CAPACITY || 'Seating Capacity' }
                                                    value={
                                                        addonItem?.seat_capacity ?
                                                        addonItem.seat_capacity_list?.find(
                                                        (opt: any) =>
                                                            opt.value === addonItem?.seat_capacity
                                                            
                                                        ) : 
                                                            addonItem.seat_capacity_list?.find(
                                                        (opt: any) =>
                                                            opt.value === addonItem?.default_passenger
                                                        )
                                                    }
                                                    handleChange={(e: any) => saveSeatingValue(addonItem, e)} fieldSetClassName="col-md-4"
                                                />
                                                )
                                            }

                                            {
                                                isCountryId  &&  addonItem.id <=7 &&
                                                getPremiumTitle(addonItem, 'title')?.length > 0 &&
                                                <React.Fragment>
                                                    <fieldset className="form-filed">
                                                        {/* <span>{getPremiumTitle(addonItem, 'title')}</span> */}
                                                        <span>{getPremiumTitle(addonItem, 'value')}</span>
                                                    </fieldset>
                                                </React.Fragment>
                                            }
                                        </div>


                                        {
                                            isShowPremiumInputBox(addonItem) && <fieldset className="form-filed col-md-4">
                                                <div className="material">
                                                    <input spellCheck={false} id="" type="text" placeholder="" name="name" className="form-input" value={isCountryId ? HELPER.addCurrencyFormatting(getPremiumAmount_ID(addonItem)) : getPremiumAmount_ID(addonItem)} onChange={(event) => {
                                                        const inputValue = event.target.value;
                                                        const finalValue = isCountryId ? HELPER.removeCurrencyFormattingId(inputValue) : inputValue;
                                                        onChangePremiumAmount_ID(addonItem, finalValue);
                                                    }} />
                                                    <label data-label={"Premium Amount"} className="form-label"></label>
                                                </div>
                                            </fieldset>
                                        }

                                        {
                                            addonItem.aon_rate ?
                                                <div className="addon-already-included">
                                                    <span> Already Included</span>
                                                </div> : null
                                        }
                                        {
                                            isShowAlreadyIncluded(addonItem) ?
                                                <div className="addon-already-included">
                                                    <span>{"Already Included"}</span>
                                                </div> : null
                                        }

                                    </>
                                }
                            </div>)
                        }
                        )
                    }
                </div>
                
            </div> : null
        );
    };

    return (
        <div className="loan-filed-sec">
            <div className="form-group-bx br-bottom">
                <div className="row">
                    <DynamicFormField
                        fields={props?.sectionItem?.blocks?.[0].fields}
                        applicationType={props.applicationType}
                        onValueChange={onValueChange}
                        onVersionSelect={props.onVersionSelect}
                        resetAddonList={resetAddonList}
                        hideFieldType={["select_addon"]}
                        apptype={props.apptype}
                        plateArea={props.plateArea}
                        setLoading={props.setLoading}
                        onPlateAreaChange={props.onPlateAreaChange}
                        setIsDetailValid ={props.setIsDetailValid}
                        onVehicleConditionChange={props.onVehicleConditionChange}
                    />
                </div>
          

            {
                addonList()?.length && !isCountryId ?
                    <div className="form-group-bx ">
                        <div className=''>
                            {   
                                addonList()?.map((addonItem: any, index: number) => {
                                    const isVehicleTypeMotorCycle = [VEHICLE_TYPE_MOTORCYCLE, VEHICLE_TYPE_MOTORCYCLE_COMMERCIAL].includes(getFieldItem('vehicle_type')?.value?.value);
                                    let className = 'row'
            
                                    if(isCountryId && addonItem?.coverage_list.length === 0){
                                       className = 'alignment'
                                    }

                                    return (<div className={className} key={index}>
                                        <fieldset className={"form-filed common-application-checkbox " + (([ADD_ONS_TYPE.RIOTS_STRIKES_CIVIL, ADD_ONS_TYPE.TOWING_ROWDSIDE].includes(addonItem.type) || (isRuleEngine() && addonItem.type === ADD_ONS_TYPE.ACTS_OF_NATURE)) ? "col-md-6" : isCountryId && className ==='alignment'? "":"col-md-12")}>
                                            <div className="custom-control custom-checkbox check-box-small col-md-12">
                                                <input checked={addonItem.is_selected} id="Individual" type="checkbox" className="custom-control-input " name="Buyer Type" onChange={(event) => {
                                                    onChangeCheckbox(addonItem, event)
                                                }} disabled={(addonItem.id === ADDON_PERSONAL_ACCIDENT && allState?.insurance?.leadDetail?.addon_detail?.find((e: any) => e.id === ADDON_PERSONAL_ACCIDENT && e.seat_capacity))|| addonItem.is_disabled} />
                                                <label className="custom-control-label checkbox-label-txt"><span>{addonItem.name}</span></label>
                                            </div>
                                        </fieldset>
                                        {
                                            addonItem?.is_selected &&
                                            <>
                                                <div className='addon-box-parent'>

                                                    {addonItem.coverage_list?.length > 0 &&
                                                        <ReactSelect
                                                            options={addonItem.coverage_list || []}
                                                            value={addonItem?.coverage_amt ? { label: isCountryId ? HELPER.addCurrencyFormatting(addonItem.coverage_amt):addonItem.coverage_amt, value: addonItem.coverage_amt } : null}
                                                            handleChange={(e: any, fieldKey: string) => onValueSelect(addonItem, e)} placeholder={translations?.CREATE_APPLICATION?.CHOOSE_COVERAGE_AMOUNT || 'Choose Coverage Amount' }
                                                            fieldKey=""
                                                            isDisabled={isCountryId?false: !isComprensive || addonItem.is_disabled ? true : false} fieldSetClassName="col-md-4"
                                                        />
                                                    }

                                                    {addonItem.type === 'pa' && <>
                                                        <ReactSelect
                                                            options={getSeatingCapacityList(addonItem)}
                                                            placeholder="Seating Capacity"
                                                            isDisabled={(props.versionSeat || allState?.insurance?.leadDetail?.addon_detail?.find((e: any) => e.id === ADDON_PERSONAL_ACCIDENT && e.seat_capacity) || isVehicleTypeMotorCycle)}
                                                            value={props.versionSeat ? { label: props.versionSeat, value: props.versionSeat } : addonItem.seat_capacity ? { label: addonItem.seat_capacity, value: addonItem.seat_capacity } : null}
                                                            handleChange={(e: any) => saveSeatingValue(addonItem, e)} fieldSetClassName="col-md-4"
                                                        />

                                                        {
                                                            !isVehicleTypeMotorCycle
                                                                ? <ReactSelect
                                                                    options={getExtraSeatingCapacityList(addonItem)}
                                                                    placeholder="Extra Seating Capacity"
                                                                    isDisabled={props.apptype === APP_TYPE_RENEWAL ? false : allState?.insurance?.leadDetail?.pa_extra_seating_capacity}
                                                                    value={addonItem?.extra_seat_value ? { label: addonItem.extra_seat_value, value: addonItem.extra_seat_value } : null}
                                                                    handleChange={(e: any) => saveExtraSeatingValue(addonItem, e)} fieldSetClassName="col-md-4"
                                                                />
                                                                : <div className='col-md-4'></div>
                                                        }
                                                    </>
                                                    }
                                                     

                                                    {
                                                        isCountryId && addonItem?.seat_capacity_list && (
                                                           <ReactSelect
                                                            options={addonItem.seat_capacity_list}
                                                            placeholder= {translations?.CREATE_APPLICATION?.SEATING_CAPACITY || 'Seating Capacity' }
                                                            value={
                                                                addonItem?.seat_capacity ?
                                                                addonItem.seat_capacity_list?.find(
                                                                (opt: any) =>
                                                                    opt.value === addonItem?.seat_capacity
                                                                   
                                                                ) : 
                                                                 addonItem.seat_capacity_list?.find(
                                                                (opt: any) =>
                                                                    opt.value === addonItem?.default_passenger
                                                                )
                                                            }
                                                            handleChange={(e: any) => saveSeatingValue(addonItem, e)} fieldSetClassName="col-md-4"
                                                        />
                                                        )
                                                    }


                                                    {
                                                        !isCountryId && 
                                                        getPremiumTitle(addonItem, 'title')?.length > 0 &&
                                                        <React.Fragment>
                                                            <fieldset className="form-filed">
                                                                <span>{getPremiumTitle(addonItem, 'title')}</span>
                                                                <span>{getPremiumTitle(addonItem, 'value')}</span>
                                                            </fieldset>
                                                        </React.Fragment>
                                                    }

                                                     {
                                                        isCountryId  &&  addonItem.id <=7 &&
                                                        getPremiumTitle(addonItem, 'title')?.length > 0 &&
                                                        <React.Fragment>
                                                            <fieldset className="form-filed">
                                                                <span>{getPremiumTitle(addonItem, 'title')}</span>
                                                                <span>{getPremiumTitle(addonItem, 'value')}</span>
                                                            </fieldset>
                                                        </React.Fragment>
                                                    }
                                                </div>


                                                {
                                                    isShowPremiumInputBox(addonItem) && <><fieldset className="form-filed col-md-4">
                                                        <div className="material">
                                                            <input id="" type="text" placeholder="" name="name" className="form-input" value={getPremiumAmount(addonItem)} onChange={(event) => {
                                                                onChangePremiumAmount(addonItem, event.target.value);
                                                            }} />
                                                            <label data-label={"Premium Amount"} className="form-label"></label>
                                                        </div>
                                                    </fieldset>
                                                    {
                                                        !isCountryId  && props.applicationType===WITHOUT_RULE_ENGINE && addonItem.type === 'pd' && 
                                                            <div className="note-text col-md-12">
                                                                <span><b>Note</b>: PD coverage amount should be same as BI coverage amount.</span>
                                                            </div>
                                                    }
                                                    </>
                                                }

                                                {
                                                    addonItem.aon_rate ?
                                                        <div className="addon-already-included">
                                                            <span> Already Included</span>
                                                        </div> : null
                                                }
                                                {
                                                    isShowAlreadyIncluded(addonItem) ?
                                                        <div className="addon-already-included">
                                                            <span>{"Already Included"}</span>
                                                        </div> : null
                                                }
                                                {/* {
                                                    !isCountryId  && props.applicationType===WITHOUT_RULE_ENGINE && addonItem.type === 'pd' && 
                                                        <div className="note-text">
                                                            <span><b>Note</b>: "PD coverage amount should be same as BI coverage amount".</span>
                                                        </div>
                                                } */}

                                            </>
                                        }
                                    </div>)
                                }
                                )
                            }
                        </div>
                        <div className="form-group-bx">
                            <div className="row">
                                <fieldset className="form-filed col-md-12 culcated-premimum-txt">
                                    <div className="col-md-6">
                                        <label>{(isCountryId)?translations?.CREATE_APPLICATION?.TOTAL_FMV || 'Total FMV' :'Total FMV'}</label>
                                        <label>{calculateTotalFMV()}</label>
                                    </div>
                                    {
                                        isComprensive && !isCountryId ?
                                        <div className="col-md-6">
                                            <label>{translations?.CREATE_APPLICATION?.TOTAL_ADDONS_PREMIUM || 'Total Add on Premium' }</label>
                                            <label>{calculateTotalPremiumValue()}</label>
                                        </div>
                                        : null 
                                    }
                                    {
                                        isCountryId && (
                                            <div className="col-md-6">
                                            <label>{translations?.CREATE_APPLICATION?.TOTAL_ADDONS_PREMIUM || 'Total Add on Premium' }</label>
                                            <label>{calculateTotalPremiumValue()}</label>
                                        </div>
                                        )
                                    }
                                   
                                </fieldset>
                            </div>
                        </div>
                        
                    </div> : null
            }
            {
                isCountryId &&  addonList()?.length > 0 && (
                    <>
                    <AddonComponent addons={basicAddons} title='Basic Add Ons'   totalRef={totalRef} onSumUpdate={(v:any) => updateAddonTotal(v, "basic")}/>
                    <AddonComponent addons={specialAddons} title='Special Add Ons'   totalRef={totalRef} onSumUpdate={(v:any) => updateAddonTotal(v, "special")}/>

                    <div className="form-group-bx">
                     <div className="row">
                        <fieldset className="form-filed col-md-12 culcated-premimum-txt">
                            <div className="col-md-6">
                                <label>{translations?.CREATE_APPLICATION?.TOTAL_FMV || 'Total FMV' }</label>
                                <label>{calculateTotalFMV()}</label>
                            </div>
                            {
                                isCountryId && (
                                    <div className="col-md-6">
                                    <label>{translations?.CREATE_APPLICATION?.TOTAL_ADDONS_PREMIUM || 'Total Add on Premium' }</label>
                                    {/* <label>{calculateTotalPremiumValue()}</label> */}
                                    {
                                        isRuleEngine() ? <label>{calculateTotalPremiumValue()}</label> : <label ref={totalRef}></label>
                                    }
                                </div>
                                )
                            }
                            
                        </fieldset>
                    </div>
                </div>
                    </>
                )
            }
              </div>
        </div >
    )
}

export default InsuranceForm
